import React from 'react'

/** Shimmer loading placeholder. */
export default function Skeleton({ className = '', width, height }) {
  const style = {}
  if (width) style.width = width
  if (height) style.height = height
  return (
    <div
      className={`animate-pulse rounded-lg bg-white/10 ${className}`}
      style={style}
      aria-hidden
    />
  )
}

export function WaveformSkeleton({ className = '' }) {
  return (
    <div className={`flex items-center justify-center gap-1 ${className}`} style={{ height: 56 }} aria-hidden>
      {Array.from({ length: 24 }).map((_, i) => (
        <Skeleton key={i} className="h-8 w-1.5 flex-1" />
      ))}
    </div>
  )
}
